import React, {useRef} from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, } from '@material-ui/core';
import { hasPermission } from '../../sc-utilities';
import ServerInstanceList from './ServerInstanceList';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const ServerInstance = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;

    let visible = columns && columns['ServerInstance'];
    let tableColumns = [
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["backend_version"] || 'Backend version', field: 'BEVersion',
            hidden: visible ? visible['BEVersion'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.BEVersion ? rowData.BEVersion : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["backend_status"] || 'Backend status', field: 'BEStatus',
            hidden: visible ? visible['BEStatus'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.BEStatus ? rowData.BEStatus : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["pxe_version"] || 'PXE version', field: 'PXEVersion',
            hidden: visible ? visible['PXEVersion'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.PXEVersion ? rowData.PXEVersion : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["pxe_status"] || 'PXE status', field: 'PXEStatus',
            hidden: visible ? visible['PXEStatus'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.PXEStatus ? rowData.PXEStatus : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["web_version"] || 'Web version', field: 'WebVersion',
            hidden: visible ? visible['WebVersion'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.WebVersion ? rowData.WebVersion : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["webs_status"] || 'Web status', field: 'WebStatus',
            hidden: visible ? visible['WebStatus'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.WebStatus ? rowData.WebStatus : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["patch_version"] || 'Patch version', field: 'PatchVersion',
            hidden: visible ? visible['PatchVersion'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.PatchVersion ? rowData.PatchVersion : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        }
    ];

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'server_list') ?
                <ServerInstanceList
                    tableColumns={tableColumns}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(ServerInstance));